import { useParams } from "react-router-dom";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { ConsultaDiarioOficial } from "./consulta-diario-oficial"
import { ConsultaDiarioOficialProvider } from "./context/consulta-diario-oficial-context"


export const ConsultaDiarioOficialFactory = () => {

    return (
        <BaseInternalFormFactory pageTitle="Consulta Diário Oficial">
            <ConsultaDiarioOficialProvider>
                <ConsultaDiarioOficial></ConsultaDiarioOficial>
            </ConsultaDiarioOficialProvider>
        </BaseInternalFormFactory>
    )
}